import { render, staticRenderFns } from "./ExpressOrderTableUserTableMobile.vue?vue&type=template&id=9b057138&scoped=true"
import script from "./ExpressOrderTableUserTableMobile.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTableUserTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ExpressOrderTableUserTableMobile.vue?vue&type=style&index=0&id=9b057138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b057138",
  null
  
)

export default component.exports